<div class="container h-100 canvas-page">
    <div *ngIf="isLoading == true" class="row h-100 justify-content-center align-items-center">
        <div class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
    </div>
    <div class="row justify-content-center align-items-center VerticalMargin mb-5"
        [ngClass]="isLoading == false ? 'visible' : 'hidden'">
        <div class="card RegularForm rounded col-11 canvas-panel"
            [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="card-body MyCardBody rounded-bottom" *ngIf="result != null">
                <div id="MyDIv" class="main-container">
                    <div class="text-right mb-4">
                        <img class="slimbar" src="{{ logoSource }}" crossorigin="*" width="60" height="60" />
                        <div class="badge text-wrap" [class.text-right]="globalService.isRTL == true"
                            [class.text-left]="globalService.isRTL == false"
                            [class.longName]="globalService.isRTL == false"
                            [class.longNameArabic]="globalService.isRTL == true" style="width: 10rem"
                            [class.ArabicFont]="globalService.isRTL == true">
                            {{ churchName }}
                        </div>
                    </div>
                    <h2 class="text-center mb-4"><strong> {{ 'TAX_STATEMENT_E9F1B96' | translate }}</strong></h2>
                    <small>{{ 'CONTRIBUTOR_NAME' | translate }}</small>
                    <small><strong>{{result.firstName}} {{result.lastName}}</strong></small><br>
                    <small>{{ 'TO_2B5FC5C' | translate }}<strong> {{ churchName }}</strong> {{ 'TAX_ID_D745456' | translate }}<strong>{{ taxId}}</strong></small><br>
                    <small>{{ 'CONTRIBUTION_PERIOD' | translate }}<strong> {{ period }} </strong></small><br>
                    <small>{{ 'TOTAL_CONTRIBUTION' | translate }}</small>
                    <small><strong> {{ total | currency }}</strong></small><br><br>
                    <small>{{ 'NO_GOODS_OR_SERVICES_WERE_PROVIDED_IN_EXCHANGE_OF_YOUR_CONTRIBUTIONS_LIS' | translate }}</small><br>
                    <br><br>
                    <table class="table table-striped entity-list-table">
                        <thead>
                            <tr>
                                <td scope="col"><small>{{ 'DATE' | translate }}</small></td>
                                <td scope="col"><small>{{ 'AMOUNT' | translate }}</small></td>
                                <td scope="col"><small>{{ 'FUND' | translate }}</small></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let donation of data; let idx = index">
                                <td><small> {{ donation.donationDate | localizedDate: 'M/d/yy' }}</small></td>
                                <td><small> {{ donation.donationAmount | currency }}</small></td>
                                <td><small> {{ donation.givingType }}</small></td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <small> {{ 'THANK_YOU_FOR_YOUR_CONTRIBUTION' | translate }}</small>
                    <br><br>
                    <small> {{ 'TREASURER' | translate }}</small><br>
                    <small><strong> {{ churchName }}</strong></small><br>
                    <small><strong> {{ currentDate | localizedDate: 'MM/dd/yyyy'}}  </strong></small><br><br>
                </div>
                <div class="row">
                    <div class="col-12 mt-4 text-center">
                        <button [class.pt-2]="globalService.isRTL == true"
                            class="btn optionButton btn-primary btn-block"
                            [class.mr-2]="globalService.isRTL == false" [class.ml-2]="globalService.isRTL == true"
                            type="button" (click)="exportAsPDF('MyDIv')">
                            {{ 'DOWNLOAD_AS_PDF' | translate }}<i class="fas fa-file-pdf ml-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>